import React from 'react';

import {colors} from 'shells/colors/colors';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

type Props = {
    isRequired: boolean;
    handleIsRequiredConfirmedChange: () => void;
    canToggleIsRequired: boolean;
    isRequiredError: string | null | undefined;
};

export function SsoRequire(props: Props) {
    const [isRequireConfirmationOpen, setIsRequireConfirmationOpen] =
        React.useState<boolean>(false);

    const handleIsRequiredSwitch = () => {
        if (props.isRequired) {
            props.handleIsRequiredConfirmedChange();
        } else {
            setIsRequireConfirmationOpen(true);
        }
    };

    const handleIsRequiredConfirmedChange = () => {
        props.handleIsRequiredConfirmedChange();
        setIsRequireConfirmationOpen(false);
    };

    return (
        <div className='flex flex-dir-col gap-8'>
            <Body size='small' isBold={true}>
                Update your login rules for your users when you are ready
            </Body>
            {props.isRequiredError && (
                <Body size='small' color='error'>
                    {props.isRequiredError}
                </Body>
            )}
            <div className='flex gap-8'>
                <Switch
                    isOn={props.isRequired}
                    isRounded={true}
                    onChange={handleIsRequiredSwitch}
                    isDisabled={!props.canToggleIsRequired}
                    isSmall={true}
                />
                <div className='flex flex-dir-col'>
                    <Body size='small' color={props.canToggleIsRequired ? 'medium' : 'light'}>
                        Require SSO for your team except those marked as exempted
                    </Body>
                    {!props.canToggleIsRequired && (
                        <div className='flex align-center gap-4'>
                            {/* @ts-expect-error */}
                            <WarningIcon size={16} fill={colors.yellow} />
                            <Body size='small'>
                                SSO must be configured with 1 exempt user and 1 verified domain
                            </Body>
                        </div>
                    )}
                </div>
            </div>
            {isRequireConfirmationOpen && (
                <ConfirmationDialog
                    message='You are requiring your team members to sign in via Single Sign-on. Other sign-in methods will no longer be available. Proceed with requirement?'
                    onCancel={() => setIsRequireConfirmationOpen(false)}
                    onConfirm={handleIsRequiredConfirmedChange}
                    cancelText='No, cancel'
                    confirmText='Yes, require SSO'
                    isConfirmDestructive={false}
                />
            )}
        </div>
    );
}
